import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as $ from "jquery";
import ViewController from "./controller";
import NavMainViewController from '../shared/nav-main/controller';
import FormViewController from '../shared/form-clear/controller';

const app = new Marionette.Application()

app.once("start", () => {
    new ViewController().render()
    new NavMainViewController().render()
    new FormViewController().render()
});

$(() => {
    app.start();
});



// WEBPACK FOOTER //
// ./django/project/@static/@modules/common/main.ts